function formsInit() {

  const forms = document.querySelectorAll('.form');
    
  if (forms) {
    for (let i = 0; i < forms.length; i++) {
      const groups = forms[i].querySelectorAll('.form_relative');
      for (let j = 0; j < groups.length; j++) {
        const control = groups[j].querySelector('input,textarea,select');
  
        // if (control.value.length > 0) {
        //   groups[j].classList.add('is-active');
        // }
  
        if (control) {
          control.addEventListener('input', () => {
            if (control.value.length > 0) {
              groups[j].classList.add('is-active');
            } else {
              groups[j].classList.remove('is-active');
            }
          });
        }
  
      }
    }
  }
};

module.exports = { formsInit };
